import ClubCostCenter from '../dto/ClubCostCenter.js';
import Error from '../model/Error.js';
import axios from 'axios';

export default class ClubCostCenterRepository {
    static findByClubId(clubId, departmentsOnly = false) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/cost-centers?departmentsOnly=${departmentsOnly}`)
                .then((response) => resolve(response.data.data.map((data) => ClubCostCenter.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static updateClubCostCenters(clubId, clubCostCenters) {
        const data = { clubCostCenters: clubCostCenters.map((clubCostCenter) => clubCostCenter.serialize()) };
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/cost-centers`, data)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
